export default "/images/vendor/flag-icons/flags/1x1/sr.svg?45463ee6f9675e59c293520a3f75ba2b";